import { PartialSearchCriterion, StringCriterion } from '../search-query-model';
import { criterionHasAttributeAndOperator } from '../search-query-model-core-utils';

import { CriterionHelpers } from './types';

export function isStringCriterion(criterion: PartialSearchCriterion): criterion is StringCriterion {
  return criterionHasAttributeAndOperator(criterion) && criterion.type === 'string';
}

export const stringCriterionHelpers: CriterionHelpers<StringCriterion> = {
  getReadableValue(criterion) {
    return `"${criterion.value}"`;
  },
  getShortReadableValue(criterion) {
    return criterion.value;
  },
  isComplete(criterion) {
    return criterion.value != null;
  },
};
